import { useEffect, useState } from "react";
import { ArrowRight, MapPin } from "lucide-react";
import axios from "axios";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

export const periodLabel = (p) => {
    if (!p) return "";
    const [y, m] = p.split("-");
    const mesi = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
    return m ? `${mesi[Number(m) - 1] || ""} ${y}` : y;
};

export const useProjects = () => {
    const [items, setItems] = useState([]);
    useEffect(() => {
        axios.get(`${API}/api/realizzazioni`).then((r) => setItems(r.data)).catch(() => {});
    }, []);
    return items;
};

// Lavori pubblicati dal pannello: link <a> normali verso /realizzazioni/<slug> (indicizzabili). Se non ce ne sono, non compare nulla.
export const LavoriRealizzati = () => {
    const items = useProjects();
    if (!items.length) return null;
    return (
        <div className="mb-16" data-testid="lavori-realizzati">
            <Reveal>
                <h3 className="font-display text-2xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-3xl">I nostri ultimi lavori</h3>
            </Reveal>
            <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {items.map((p, i) => (
                    <Reveal key={p.id} delay={0.04 * i}>
                        <a href={`/realizzazioni/${p.slug}`} data-testid={`lavoro-card-${p.slug}`} className="group block h-full overflow-hidden rounded-2xl border border-slate-200 bg-white transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_-12px_rgba(11,31,58,0.18)]">
                            <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                                {p.cover && <img src={`${API}${p.cover}`} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                            </div>
                            <div className="p-5">
                                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E30613]">{p.division}</span>
                                <h4 className="font-display mt-2 text-lg font-extrabold leading-snug text-[#0B1F3A]">{p.title}</h4>
                                <p className="mt-2 flex items-center gap-1.5 text-xs text-[#4F5D70]"><MapPin className="h-3.5 w-3.5 text-[#E30613]" />{[p.city, p.province && `(${p.province})`].filter(Boolean).join(" ")}{p.period && ` · ${periodLabel(p.period)}`}</p>
                                <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#0B1F3A]">Vedi il lavoro <ArrowRight className="h-4 w-4 text-[#E30613] transition-transform group-hover:translate-x-1" /></span>
                            </div>
                        </a>
                    </Reveal>
                ))}
            </div>
        </div>
    );
};
